import isEmpty from "../../utils/isEmpty";

const initialState = {
  user: {},
  isAuthenticated: false,
};

const authReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SET_USER":
      return {
        ...state,
        user: payload,
        isAuthenticated: !isEmpty(payload),
      };

    default:
      return state;
  }
};

export default authReducer;
